import SubHeader from './subHeader';
import CharityLogo from './CharityLogo';
import React from 'react';
import templateData from '../utility/getTemplateData';
import BannerHeader, { BackgroundBanner } from './GN/bannerHeader.js';
import PropTypes from 'prop-types';

const HeaderDNW = ({ isLanding }) => {
  const hasLogo = templateData.hasLogo,
    donationId = templateData.donationId,
    orgName = templateData.charityName ?? '',
    subHeaderLabel = templateData.donationName ?? '',
    bannerUrl = templateData.bannerUrl ?? '';

  return (
    <div>
      {bannerUrl && (
        <BannerHeader type="backgroundBanner">
          <BackgroundBanner bannerURL={bannerUrl} />
        </BannerHeader>
      )}
      {hasLogo && <CharityLogo />}
      <SubHeader
        donationId={donationId}
        orgName={orgName}
        label={subHeaderLabel}
        page="landing"
        isLanding={isLanding}
      />
    </div>
  );
};

HeaderDNW.propTypes = {
  isLanding: PropTypes.bool,
};

export default HeaderDNW;
